import { Box, Divider } from '@mui/material';
import React from 'react';
import { ActionButton } from '../../ActionButton';
import { ResponsiveActionToolbar } from '../../ResponsiveActionToolbar';
export const ActionsAreaLarge = (props) => {
    var _a;
    const showGlobalActions = props.globalActions != null && props.globalActions.length > 0;
    return (React.createElement(React.Fragment, null,
        showGlobalActions && (React.createElement(ResponsiveActionToolbar, { actions: (_a = props.globalActions) !== null && _a !== void 0 ? _a : [], align: 'right', variant: 'outlined', gap: 2, sx: { flexGrow: 1, flexShrink: 1, overflow: 'hidden' }, "data-test": 'global-actions' })),
        showGlobalActions && (props.secondaryAction || props.mainAction) && React.createElement(Divider, { orientation: 'vertical', flexItem: true }),
        (props.secondaryAction || props.mainAction) && (React.createElement(Box, { sx: {
                display: 'flex',
                gap: 2,
                flexGrow: showGlobalActions ? 0 : 1,
                justifyContent: showGlobalActions ? undefined : 'flex-end',
            } },
            props.secondaryAction && (React.createElement(ActionButton, { action: props.secondaryAction, variant: 'outlined', "default-data-test": 'secondary-action-button' })),
            props.mainAction && (React.createElement(ActionButton, { action: props.mainAction, anchor: 'right', variant: 'contained', "default-data-test": 'main-action-button' }))))));
};
